import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { splitOrders, createSubBatchNew, markAsRemoteOrders, filterRemoteOrders, getBlindScanBatchList } from '../../actions/tosbActions';
import UniDialog from '../Common/UniDialog';
import { getUserPreference } from "../../utilities/common";
import { handleTransferOrdersSubBatch, openTransferOrdersSubBatch, getSelectedOrders, showAlertSnackbar } from '../../reducers/uiSlice';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TextField, Button } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useTranslation } from 'react-i18next';
import BlindBatchList from './BlindBatchList/index';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
    container: {
        display: 'flex'
    }
}));

const FixedTextFieldZone = withStyles((theme) => ({
    root: {
        '& .MuiOutlinedInput-input': {
            padding: '8px !important',
        },
        width: '80%'
    },
}))(TextField);

function TransferOrdersSubBatch() {
    const classes = useStyles();
    const {t} = useTranslation('transferOrdersSubBatch');
    const dispatch = useDispatch();

    const openModal = useSelector(openTransferOrdersSubBatch);
    let selectedOrders = useSelector(getSelectedOrders);
    let userPref = getUserPreference();

    const [disable, setDisable] = useState(true);
    const [batch, setBatch] = useState('');
    const [ordersStr, setOrdersStr] = useState('');
    const [errorOpen, setErrorOpen] = useState(false);
    const [isChecked, setIsChecked] = useState([]);
    const [batchNos, setBatchNos] = useState('');
    const [createdBatch, setCreatedBatch] = useState('');
    const [loading, setLoading] = useState(false);
    const [batchNosRemote, setBatchNosRemote] = useState('');
    const [loadingRemote, setLoadingRemote] = useState(false);
    const [batchNosFilter, setBatchNosFilter] = useState('');
    const [createdBatchFilterRemote, setCreatedBatchFilterRemote] = useState('');
    const [createdBatchFilterRegular, setCreatedBatchFilterRegular] = useState('');
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [blindBatchNos, setBlindBatchNos] = useState('');
    const [blindOpen, setBlindOpen] = useState(false);
    const [blindBatchRes, setBlindBatchRes] = useState([]);

    const states = [
        198,
        199,
        200,
        195,
        192
    ]

    const handleInputBatch = (event) => {
        setBatch(event.target.value)
    }
    const handleInputBatchNos = (event) => {
        setBatchNos(event.target.value);
    }
    const handleInputBatchNosFilter = (event) => {
        setBatchNosFilter(event.target.value);
    }
    const toggleCheckboxValue = (index) => {
        setIsChecked(isChecked.map((v, i) => (i === index ? !v : v)));
    }
    const handleInputBatchNosRemote = (event) => {
        setBatchNosRemote(event.target.value);
    }
    const handleBlindBatchNos = (event) => {
        setBlindBatchNos(event.target.value)
    }
    const handleBlindClose = () => {
        setBlindOpen(false);
        setBlindBatchNos('');
        setBlindBatchRes([]);
    }

    useEffect(() => {
        if(selectedOrders.length > 0) {            
            setDisable(false);
        }
    }, [selectedOrders])
    useEffect(() => {
        if(openModal) {
            setBlindOpen(false);
            setBlindBatchRes([]);
            if(selectedOrders.length > 0) {            
                setErrorOpen(false);
            } else {
                setDisable(true);
                setErrorOpen(true);
            }
        } else {
            setErrorOpen(false);
        }
        setCreatedBatch('');
        setCreatedBatchFilterRemote('');
        setCreatedBatchFilterRegular('');
    }, [openModal])
    useEffect(() => {
        if(selectedOrders.length > 0) {
            setOrdersStr(selectedOrders.join());
        }
    }, [selectedOrders])
    useEffect(() => {
        setIsChecked(states.slice().fill(false));
    }, [])

    function handleSubmit() {
        let selectedStates = '';
        isChecked.map((check, index) => {
            if(check) {
                selectedStates = selectedStates.concat(',' + states[index]);
            }
        })
        selectedStates = selectedStates.substring(1);
        let is_dedault = 1;
        if(selectedStates) {
            is_dedault = 0;
        }
        let newBatches = batchNos.replace(/，/ig,',');
        setLoading(true);
        dispatch(createSubBatchNew(is_dedault, userPref.userCity, newBatches, selectedStates))
        .then((res) => {
            setCreatedBatch(res.data.sub_batch_no);
            setLoading(false);
        })
        .catch((err) => {
            console.log(err);
            setLoading(false);
        })
    }
    function handleMarkRemote() {
        let newBatches = batchNosRemote.replace(/，/ig,',');
        setLoadingRemote(true);
        dispatch(markAsRemoteOrders(newBatches))
        .then((res) => {
            dispatch(showAlertSnackbar({message: t('success'), type: 'success'}))
            setLoadingRemote(false);
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: t('fail'), type: 'error'}))
            setLoadingRemote(false);
        })
    }
    function handleSubmitFilter() {
        let newBatches = batchNosFilter.replace(/，/ig,',');
        setLoadingFilter(true);
        dispatch(filterRemoteOrders(userPref.userCity, newBatches))
        .then((res) => {
            setCreatedBatchFilterRemote(res.data.remote_sub_batch);
            setCreatedBatchFilterRegular(res.data.regular_sub_batch);           
            setLoadingFilter(false);
        })
        .catch((err) => {
            setLoadingFilter(false);
        })
    }
    function handleSubmitBlind() {
        dispatch(getBlindScanBatchList(userPref.userCity, blindBatchNos))
        .then((res) => {
            setBlindBatchRes(res.blind_scan_batch);
            setBlindOpen(true);
        })
    }

    return (
        <Fragment>
            <BlindBatchList 
                open={blindOpen} 
                handleClose={handleBlindClose}
                blindBatchRes={blindBatchRes}
            />
            <UniDialog
                title={t('title_transfer_orders_sub_batch')}
                maxWidth='sm'
                disableDefaultButtons
                open={openModal}
                onClose={handleClose}
                fullWidth
            >
                <div style={{ display: 'flex', flexDirection: 'column', padding: 20 }}>
                    <div>
                        <span style={{ marginRight: 10}}>{t('search_new_batch')}</span>
                    </div>
                    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                        <FixedTextFieldZone
                            variant="outlined"
                            style={{ marginRight: 10 }}
                            onChange={handleBlindBatchNos}
                            placeholder={t('input_sub_batch_nos')}
                            value={blindBatchNos}
                        />
                        <Button
                            variant="contained" 
                            color="primary"
                            onClick={handleSubmitBlind}
                            disabled={!blindBatchNos}
                        >
                            {t('submit')}
                        </Button>
                    </div>
                    <div style={{ marginBottom: 10, marginTop: 30 }}>
                        <span style={{ marginRight: 10}}>{t('split')}</span>
                        {errorOpen && <span style={{ color: '#f44336' }}>{t('no_selected_orders')}</span>}
                    </div>
                    <div className={classes.container}>
                        <FixedTextFieldZone
                            disabled={disable}
                            variant="outlined"
                            style={{ marginRight: 10 }}
                            onChange={handleInputBatch}
                            placeholder={t('input_sub_batch')}
                        />
                        <Button
                            variant="contained" 
                            color="primary"
                            disabled={disable}
                            onClick={handleTransfer}
                        >
                        {t('submit')}
                        </Button>
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <div style={{ display: 'table', alignItems: 'center' }}>
                            <span>{t('trans_state')}</span>
                            {
                                states.map((state, index) => (
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox 
                                            onClick={() => {toggleCheckboxValue(index)}}
                                            checked={isChecked[index]}
                                        />
                                        <span>{t(`orderStatus:${state}`)}</span>
                                    </span>
                                ))
                            }
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <FixedTextFieldZone
                                variant="outlined"
                                style={{ marginRight: 10 }}
                                onChange={handleInputBatchNos}
                                placeholder={t('input_batch_nos')}
                            />
                            <Button
                                variant="contained" 
                                color="primary"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {t('submit')}
                            </Button>
                            {   loading && 
                                <CircularProgress
                                    size={30}
                                    style={{ marginLeft: 5 }}
                                />
                            }
                        </div>   
                        {
                            createdBatch && 
                            <div style={{ marginTop: 10 }}>
                                <span>{t("create")}</span><span>{createdBatch}</span>
                            </div>
                        }                     
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <span style={{ marginRight: 10}}>{t('markAsRemote')}</span>
                    </div>
                    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                        <FixedTextFieldZone
                            variant="outlined"
                            style={{ marginRight: 10 }}
                            onChange={handleInputBatchNosRemote}
                            placeholder={t('input_sub_batch_nos')}
                        />
                        <Button
                            variant="contained" 
                            color="primary"
                            onClick={handleMarkRemote}
                            disabled={loadingRemote}
                        >
                            {t('submit')}
                        </Button>
                        {   loadingRemote && 
                            <CircularProgress
                                size={30}
                                style={{ marginLeft: 5 }}
                            />
                        }
                    </div>
                    <div style={{ marginTop: 20 }}>
                        <div>
                            {t('second_tier_transfer')}
                        </div>
                        <div style={{ marginTop: 10, display: 'flex', alignItems: 'center' }}>
                            <FixedTextFieldZone
                                variant="outlined"
                                style={{ marginRight: 10 }}
                                onChange={handleInputBatchNosFilter}
                                placeholder={t('input_batch_nos')}
                            />
                            <Button
                                variant="contained" 
                                color="primary"
                                onClick={handleSubmitFilter}
                                disabled={loadingFilter}
                            >
                                {t('submit')}
                            </Button>
                            {   loadingFilter && 
                                <CircularProgress
                                    size={30}
                                    style={{ marginLeft: 5 }}
                                />
                            }
                        </div>   
                        {
                            createdBatchFilterRemote && 
                            <div style={{ marginTop: 10 }}>
                                <span>{t("created_batch_filter_remote")}</span><span>{createdBatchFilterRemote}</span>
                            </div>
                        }   
                        {
                            createdBatchFilterRegular && 
                            <div style={{ marginTop: 10 }}>
                                <span>{t("created_batch_filter_regular")}</span><span>{createdBatchFilterRegular}</span>
                            </div>
                        }                    
                    </div>
                </div>
            </UniDialog>
        </Fragment>        
    );
    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleTransferOrdersSubBatch(false))
    }

    function handleTransfer() {
        dispatch(splitOrders(batch, ordersStr))
        .then(() => {
            dispatch(showAlertSnackbar({message: t('success'), type: 'success'}))
            handleClose();
        })
        .catch(() => {
            dispatch(showAlertSnackbar({message: t('fail'), type: 'error'}))
        })
    }
}

export default TransferOrdersSubBatch;